import { IPoint2d } from '@/editor/math/IPoint2d';
import { globalStores } from '..';
import { getBoxOutline } from '@/editor/utils';
import { EColumnType } from '@/editor/data/model/model';

export function getAllStructOutlines(excludeColumnId?: string) {
  const columnDatas = globalStores.structStore.getColumnDatas();

  const outlines: { start: IPoint2d; end: IPoint2d }[] = [];
  for (const columnData of columnDatas) {
    if (excludeColumnId && columnData.id === excludeColumnId) {
      continue;
    }

    if (columnData.type === EColumnType.squareColumn) {
      const outline = getBoxOutline(columnData);
      outlines.push(...outline);
    } else if (columnData.type === EColumnType.cylinder) {
      const outline = getBoxOutline({
        center: columnData.center,
        width: columnData.radius * 2,
        thickness: columnData.radius * 2,
        rotation: columnData.rotation
      });
      outlines.push(...outline);
    }
  }

  return outlines;
}
